import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Minus, ArrowUpRight, ArrowDownRight } from 'lucide-react';

export const formatCurrency = (v) => {
  if (v == null || isNaN(v)) return '£0';
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(v);
};

export function PulseCard({ title, current, previous, change, format = 'number', icon: Icon, color, subtitle }) {
  const isUp = change > 0;
  const isDown = change < 0;
  const displayValue = format === 'currency' ? formatCurrency(current) : current;
  const prevDisplayValue = format === 'currency' ? formatCurrency(previous) : previous;

  return (
    <Card className="bg-white border-stone-100 shadow-sm overflow-hidden" data-testid={`pulse-card-${title.toLowerCase().replace(/\s/g, '-')}`}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between mb-3">
          <div className={`p-2 rounded-lg ${color}`}>
            <Icon className="w-5 h-5" />
          </div>
          {change !== null && change !== undefined && (
            <div className={`flex items-center gap-1 text-sm font-semibold rounded-full px-2.5 py-0.5 ${
              isUp ? 'bg-green-50 text-green-700' : isDown ? 'bg-red-50 text-red-700' : 'bg-stone-50 text-stone-500'
            }`}>
              {isUp ? <ArrowUpRight className="w-3.5 h-3.5" /> : isDown ? <ArrowDownRight className="w-3.5 h-3.5" /> : <Minus className="w-3.5 h-3.5" />}
              {isUp ? '+' : ''}{change}%
            </div>
          )}
        </div>
        <p className="text-2xl font-bold text-stone-900 mb-1">{displayValue}</p>
        <p className="text-xs text-stone-500">{title}</p>
        {previous !== null && previous !== undefined && (
          <p className="text-[11px] text-stone-400 mt-1">Last week: {prevDisplayValue}</p>
        )}
        {subtitle && <p className="text-[11px] text-stone-400 mt-0.5">{subtitle}</p>}
      </CardContent>
    </Card>
  );
}

export function getWeekDates(offset) {
  const now = new Date();
  const day = now.getDay();
  const diff = now.getDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(now);
  monday.setDate(diff + (offset * 7));
  monday.setHours(0, 0, 0, 0);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return { monday, sunday };
}

export function formatWeekLabel(offset) {
  const { monday, sunday } = getWeekDates(offset);
  const start = monday.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  const end = sunday.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  return `${start} – ${end}`;
}
